// extracted by mini-css-extract-plugin
module.exports = {"warning":"warning-module--warning--3sRY_"};